// import axiosService from 'src/services/axiosService';
// import { CONFIG } from '../../configs';

import {sleep} from "../../utils/utils";
import {Test, TEST_DATA} from "../../mockApi/testData";

/**
 * Login Function
 * @param {model} include:
 * @param username
 * @param password
 */
export const getListTest = () => {
  let res = []
  for (let i = 0; i < 5; i++) {
    let item = new Test(TEST_DATA);
    item.generalInformation.testID += i;
    res.push(item)
  }

  return {status: 200, data: res};
  // return axiosService.post(`${CONFIG.API_URL.BASE}/auth`, data)
};
export const apiAddTest = async (data) => {
  await sleep(1000);
  const res = new Test(data);
  return {status: 200, data: res};
  // return axiosService.post(`${CONFIG.API_URL.BASE}/auth`, data)
};

export const apiDeleteTest = async (data) => {
  await sleep(1000);
  return {status: 200, data: ''};
  // return axiosService.post(`${CONFIG.API_URL.BASE}/auth`, data)
};

export const apiEditTest = async (data) => {
  await sleep(1000);
  return {status: 200, data: data};
  // return axiosService.post(`${CONFIG.API_URL.BASE}/auth`, data)
};
